import { Col } from "@/stores/slices/paperSlice";
import { chartColKeys } from "./aiColsConst";

export const getColConsumePrice = (cols: Col[], balance: number) => {
  const c = {
    stdCount: 0,
    stdConsume: 0,
    stdUnitPrice: 0,
    customUnitPrice: 0,
    customCount: 0,
    customConsume: 0,
    chartCount: 0,
    chartConsume: 0,
    chartUnitPrice: 0,
    userBalance: 0,
  };
  cols.forEach((col) => {
    if (chartColKeys.includes(col.key)) {
      c.chartConsume += col.cost;
      c.chartCount += col.cellCount;
    } else if (col.isCustom) {
      c.customConsume += col.cost;
      c.customCount += col.cellCount;
    } else {
      c.stdConsume += col.cost;
      c.stdCount += col.cellCount;
    }
  });
  c.chartUnitPrice = Number(((c.chartConsume / c.chartCount) || 0).toFixed(0));
  c.stdUnitPrice = Number(((c.stdConsume / c.stdCount) || 0).toFixed(0));
  c.customUnitPrice = Number(((c.customConsume / c.customCount) || 0).toFixed(0));
  c.userBalance = balance;
  return c;
}
